import { FooterInfoData } from '../types';

export const FOOTER_DATA: FooterInfoData = {
  nom_du_magasin: '',
  siteName: '',
  description_courte: '',
  telephone: '',
  email: '',
  adresse: '',
  heures_ouverture: '',
  lien_map: '',
  facebook_url: '',
  instagram_url: '',
  whatsapp_number: '',
  bouton_label: '',
  bouton_lien: '',
  seo_title: '',
  seo_description: '',
  seo_keywords: '',
  smtp_host: '',
  smtp_port: '587',
  smtp_user: '',
  smtp_pass: '',
  smtp_encryption: 'STARTTLS',
  imap_host: '',
  imap_port: '993',
  imap_user: '',
  imap_pass: '',
  imap_encryption: 'SSL',
  booking_disabled_days: [],
  booking_hours_config: [],
  booking_disabled_dates: [],
  booking_special_hours: {}
};
